import { render, staticRenderFns } from "./xinziMingXi.vue?vue&type=template&id=49357622&scoped=true&"
import script from "./xinziMingXi.vue?vue&type=script&lang=js&"
export * from "./xinziMingXi.vue?vue&type=script&lang=js&"
import style0 from "./xinziMingXi.vue?vue&type=style&index=0&id=49357622&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49357622",
  null
  
)

export default component.exports